"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'user.form.language.label': 'Language',
    'user.form.language.placeholder': 'Select language',
    'user.form.userGroup.label': 'User Group',
    'user.form.userGroup.placeholder': 'Select user group',
    'user.form.userGroup.show': 'Show User Groups',
    'user.form.userGroup.add': 'Add new user group',
    'user.form.userGroup.search_placeholder': 'Search user groups...',
    'user.form.title.edit': 'Edit User',
    'user.form.title.add': 'Add User',
    'user.form.back': 'Back',
    'user.form.name.label': 'Name',
    'user.form.name.placeholder': 'John',
    'user.form.last_name.label': 'Last Name',
    'user.form.last_name.placeholder': 'Doe',
    'user.form.username.label': 'Login',
    'user.form.username.placeholder': 'johndoe',
    'user.form.email.label': 'Email',
    'user.form.email.placeholder': 'email@address.com',
    'user.form.password.label': 'Password',
    'user.form.password.new.label': 'New Password (leave empty to keep current)',
    'user.form.password.placeholder': 'Password',
    'user.form.password.repeat.label': 'Repeat Password',
    'user.form.password.repeat.new.label': 'Repeat Password (leave empty to keep current)',
    'user.form.password.repeat.placeholder': 'Repeat Password',
    'user.form.role.label': 'Role',
    'user.form.role.placeholder': 'Select role',
    'user.form.active.label': 'Active',
    'user.form.companies.label': 'Assigned companies',
    'user.form.companies.placeholder': 'Select companies',
    'user.form.company.label': 'Company',
    'user.form.company.placeholder': 'Select a company...',
    'user.form.submit.update': 'Update User',
    'user.form.submit.create': 'Create User',
    'user.form.acl.loadError': 'Failed to load ACL meta data:',
    'user.form.load.debug': 'Loading user:',
    'user.form.load.error': 'Failed to load user',
    'user.form.submit.updateError': 'Failed to update user',
    'user.form.submit.createError': 'Failed to create user',
    'user.form.submit.updateSuccess': 'User updated successfully',
    'user.form.submit.createSuccess': 'User created successfully',
    'user.form.preview.title': 'Access Preview',
    'user.form.preview.selectedGroup': 'Selected Group',
    'user.form.preview.permissions': 'Permissions',
    'user.form.preview.selectGroup': 'Select a user group to preview access permissions',
    'user.form.preview.noAccess': 'No access permissions available',
    'user.form.error.userGroup_required': 'User group selection is required',
};
